import { STORE_TYPE_LITE } from '../../../lib/const';
import { getSafeStoreInfoRequestContext } from '../../../lib/context';
import { checkIsExternalCheckout } from '../../../lib/storeInfo';
import {
    ONBOARDING_EXTERNAL_CHECKOUT_STEPS,
    ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS,
    ONBOARDING_KIT_STEPS,
    ONBOARDING_KIT_SUBTASKS,
    ONBOARDING_LITE_STEPS,
    ONBOARDING_LITE_SUBTASKS,
} from './constants';
import { type OnboardingStage, type OnboardingSubtask } from './types';

export type OnboardingVariant = 'kit' | 'external' | 'lite';

export interface OnboardingConfig {
    readonly publishStageSlug: OnboardingStage;
    readonly stageSlugs: readonly OnboardingStage[];
    readonly subtaskSlugs: readonly OnboardingSubtask[];
}

const ONBOARDING_CONFIGS: Record<OnboardingVariant, OnboardingConfig> = {
    kit: {
        publishStageSlug: ONBOARDING_KIT_STEPS.PUBLISH,
        stageSlugs: Object.values(ONBOARDING_KIT_STEPS),
        subtaskSlugs: Object.values(ONBOARDING_KIT_SUBTASKS),
    },
    external: {
        publishStageSlug: ONBOARDING_EXTERNAL_CHECKOUT_STEPS.PUBLISH,
        stageSlugs: Object.values(ONBOARDING_EXTERNAL_CHECKOUT_STEPS),
        subtaskSlugs: Object.values(ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS),
    },
    lite: {
        publishStageSlug: ONBOARDING_LITE_STEPS.PUBLISH,
        stageSlugs: Object.values(ONBOARDING_LITE_STEPS),
        subtaskSlugs: Object.values(ONBOARDING_LITE_SUBTASKS),
    },
};

export const getOnboardingVariant = (): OnboardingVariant => {
    const storeType = getSafeStoreInfoRequestContext().type;

    if (storeType === STORE_TYPE_LITE) {
        return 'lite';
    }

    if (checkIsExternalCheckout()) {
        return 'external';
    }

    return 'kit';
};

export const getOnboardingConfig = (): OnboardingConfig => ONBOARDING_CONFIGS[getOnboardingVariant()];
